export default __webpack_public_path__ + "static/media/person-4.ff4addaf.jpg";